const root = 'MyStoresPage'

export const TestId = {
  header: `${root}-header`,
  addNewStoreButton: `${root}-addNewStoreButton`,
}
